import { render } from "./ItemDetalhar.vue?vue&type=template&id=73e42550"
import script from "./ItemDetalhar.vue?vue&type=script&lang=js"
export * from "./ItemDetalhar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__